import { render, staticRenderFns } from "./StatusDestination.vue?vue&type=template&id=50885b61&"
import script from "./StatusDestination.vue?vue&type=script&lang=js&"
export * from "./StatusDestination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports